export const goblinDead = new Image();
goblinDead.src = "assets/characterSprites/goblin/Death.png";
goblinDead.width = 1200/8;
goblinDead.height = 150/1;
goblinDead.yOffset = 40;
goblinDead.xOffset = 100;
goblinDead.cycleLoop = [0,1,2,3,4,5,6,7];